import React from "react";

interface TermsParagraphProps {
  children: any;
  className?: string;
}

const TermsParagraph: React.FC<TermsParagraphProps> = ({
  children,
  className,
}) => {
  return (
    <p className={`mb-3 text-justify text-base ${className}`}>{children}</p>
  );
};

TermsParagraph.defaultProps = {
  className: "",
};

TermsParagraph.displayName = "TermsParagraph";

export default TermsParagraph;
